<div class="formgrid grid mt-2 mr-2">
    <div class="col-3 font-bold">
        <app-auto-complete
            [isValid]="isActiveIngredientValid"
            [label]="'Active'"
            [id]="'moleculePk'"
            [placeholder]="'Start typing to search'"
            [isRequired]="true"
            [forceSelection]="true"
            [showClear]="true"
            [optionLabel]="'moleculeName'"
            [suggestions]="activeIngredients"
            [model]="selectedActiveIngredient"
            (queryFilterEvent)="onQueryFilterEvent($event)"
            (selectionChangedEvent)="activeIngredientSelectionChanged($event)"
            (onClearEvent)="activeIngredientOnClear($event)"
            (onDropdownClickEvent)="activeIngredientDropdownClicked($event)" >
        </app-auto-complete>
    </div>
    <div class="col-3 font-bold">
        <app-dropdown
          class="w-10"
          [id]="'geographyInput'"
          [isRequired]="true"
          [isValid]="isGeographyValid"
          [label]="'Geography'"
          [loading]="loadingGeographies"
          [model]="selectedGeography"
          [optionLabel]="'name'"
          [options]="geographies"
          [placeholder]="'Select a Geography'"
          [showClear]="true"
          [useTitle]="true"
          (onChangeEvent)="geographySelectionChanged($event)"
        />
    </div>

    <div class="col-6 font-bold" style="width: 40%;">
        <app-input-text [label]="'Created by'" [useTitle]="true" class="w-10" [id]="'createdByInput'"
            [disabled]="true" [model]="createdBy"></app-input-text>
    </div>
</div>
